const enc = new TextEncoder();

export default function stringNumBytes(str: string) {
  return enc.encode(str).length;
}
